import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { Me } from '../../../../services/users.service';
import { ConfigService } from '../../../../../../services/config.service';

@Component({
    selector: 'app-secondary-navigation',
    templateUrl: './secondary-navigation.component.html',
    styleUrls: ['./secondary-navigation.component.scss'],
})
export class SecondaryNavigationComponent implements OnInit {
    shortName: string;
    isCustomerLite: boolean;
    me: Me;

    @Output() navItemClick = new EventEmitter();

    constructor(public configService: ConfigService) {}

    ngOnInit(): void {
        this.me = this.configService.me;
        this.shortName = `${this.me.name.firstName.charAt(0)}${this.me.name.familyName.charAt(0)}`;
        this.isCustomerLite = this.configService.isCustomerLite();
    }
}
